import { Box, Divider, Stack, Typography } from '@mui/material';

/**
 * SectionHeader — Shared card section heading with optional icon and accent divider.
 *
 * @param {string}        title    — Section title text
 * @param {ReactElement}  [icon]   — Optional MUI icon element (e.g. <HomeIcon />)
 * @param {object}        [sx]     — Additional sx overrides on the root Box
 */
const SectionHeader = ({ title, icon, sx }) => (
  <Box sx={{ mb: 1, ...sx }}>
    <Stack direction="row" spacing={0.75} alignItems="center">
      {icon && (
        <Box sx={{ color: 'secondary.main', display: 'flex', alignItems: 'center', '& .MuiSvgIcon-root': { fontSize: '1rem' } }}>
          {icon}
        </Box>
      )}
      <Typography variant="subtitle2" fontWeight={700} sx={{ letterSpacing: '-0.005em' }}>
        {title}
      </Typography>
    </Stack>
    <Divider sx={{ mt: 0.5, borderColor: 'secondary.main', borderBottomWidth: 2, width: 36, borderRadius: 1 }} />
  </Box>
);

export default SectionHeader;
